/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlannedAuthSupportsTransferList } from '../../models/planned-auth-supports-transfer-list';

export interface GetPlannedAuthSupportsTransfersToSubscription$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
}

export function getPlannedAuthSupportsTransfersToSubscription(http: HttpClient, rootUrl: string, params: GetPlannedAuthSupportsTransfersToSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedAuthSupportsTransferList>> {
  const rb = new RequestBuilder(rootUrl, getPlannedAuthSupportsTransfersToSubscription.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlannedAuthSupportsTransferList>;
    })
  );
}

getPlannedAuthSupportsTransfersToSubscription.PATH = '/subscriptions/{uid}/auth-supports/transfer/planned';
